
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import ParkEventsTable from "@/modules/ParksConfig/components/ParkEvents/ParkEventsTable.vue";
  import ParkEventsFilters from "@/modules/ParksConfig/components/ParkEvents/ParkEventsFilters.vue";
  import {IParkEvent} from "@/modules/ParksConfig/interfaces/park-event.interface";
  import {bus} from "@/plugins/bus";

  @Component({
    components: {
      ParkEventsFilters,
      ParkEventsTable,
      AppDialog,
    },
  })
  export default class ParkEventsPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'parksConfig', dialogName: 'parkEvents' };

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
